export const API_URL: string | undefined = import.meta.env.VITE_API_URL;
export const CARRIER_TURVO_PROFILE_URL: string | undefined = import.meta.env
  .VITE_CARRIER_TURVO_PROFILE_URL;
export const TURVO_SHIPMENT_URL: string | undefined = import.meta.env
  .VITE_TURVO_SHIPMENT_URL;
export const SPELLBAR_CONFIG_ENDPOINT_URL: string | undefined = import.meta.env
  .VITE_SPELLBAR_URL;
export const AUTH_CLIENT_ID: string | undefined = import.meta.env
  .VITE_AUTH_CLIENT_ID;
export const NAVBAR_API: string | undefined = import.meta.env.VITE_NAVBAR_API;
export const MARKETPLACE_URL: string | undefined = import.meta.env
  .VITE_MARKETPLACE_URL;
export const RMIS_URL: string | undefined = import.meta.env.VITE_RMIS_URL;
export const CARRIER411_PROFILE_URL: string | undefined = import.meta.env
  .VITE_CARRIER411_PROFILE_URL;
export const FMCSA_PROFILE_URL: string | undefined = import.meta.env
  .VITE_FMCSA_PROFILE_URL;
export const CO_API_URL =
  import.meta.env.VITE_CO_API_URL ?? "no-api-route-defined";
export const CO_MSAL_SCOPE: string =
  import.meta.env.VITE_CO_MSAL_SCOPE ?? "no-scope-provided";
export const CO_MSAL_REDIRECT_URI: string =
  import.meta.env.VITE_CO_MSAL_REDIRECT_URI ?? "no-redirect-uri-provided";
export const CO_MSAL_CLIENT_ID: string =
  import.meta.env.VITE_CO_MSAL_CLIENT_ID ?? "no-msal-client-id-provided";
export const GOOGLE_MAPS_API_KEY: string =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "no-google-maps-key-provided";

export const IS_EU: boolean =
  AUTH_CLIENT_ID?.toLowerCase().endsWith("eu") ?? false;

export const ENABLE_CENTRAL_DISPATCH: boolean =
  import.meta.env.VITE_ENABLE_CENTRAL_DISPATCH === "true";
